
// tslint:disable-next-line:class-name
export class tokenStorage {
  static getItem(name: string) {
    return localStorage.getItem(name);
  }

  static setItem(name: string, value: string) {
    localStorage.setItem(name, value);
  }

  static removeItem(name: string) {
    localStorage.removeItem(name);
  }

  static extendLife(name: string, token: string) {
    const item = tokenStorage.getItem(name);
    tokenStorage.removeItem(name);
    if (!item) {
      return false;
    }

    const tokenObj = JSON.parse(item);
    tokenObj.token = token;

    tokenStorage.setItem(name, JSON.stringify(tokenObj));
  }
}



// WEBPACK FOOTER //
// E:/proj/news12/zb-n12/scadmin/client/src/app/shared/core/tokenStorage.ts